/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Spinner,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileType } from '@Types/globalSetting';
import common from 'src/utils/common';

function ImportModal({
  isVisible,
  onClose,
  onImport,
  importFields,
  acceptFileType = FileType.TXT,
}: {
  isVisible: boolean;
  onClose: () => void;
  onImport: (e: any) => void;
  importFields?: string[];
  acceptFileType?: FileType;
}) {
  const { t } = useTranslation('common');
  const [file, setFile] = React.useState<File | null>(null);
  const [isImporting, setIsImporting] = React.useState(false);
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const variant = 'secondary';
  const uploadInputRef = React.useRef<HTMLInputElement>(null);

  function processText(c: string) {
    const content = c.split(/\r?\n/);
    const arr: string[] = [];
    content.forEach((line: string) => {
      if (line) {
        arr.push(line);
      }
    });
    onImport(arr);
  }

  function processCSV(c: string) {
    const json: any[] = common.parseCSVToJSON(c, importFields);
    onImport(json);
  }

  const handleFileRead = (file: File) => {
    //just for DLP template,it will import a file to backend
    if (file.type === 'text/xml') {
      const formData = new FormData();
      formData.append('file', file);
      onImport(formData);
      return;
    }
    const reader = new FileReader();
    try {
      reader.onload = (e: any) => {
        const content = e.target.result;
        console.log('content', content, file.type);
        // 根据文件类型进行适当的处理
        if (file.type === 'text/csv') {
          // CSV文件处理
          processCSV(content);
        } else {
          // 文本文件处理
          processText(content);
        }
      };
    } catch (e) {
      console.log(e);
    }

    reader.readAsText(file);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };
  const handleUploadClick = React.useCallback(() => {
    if (!file) {
      return;
    }
    setIsImporting(true);
    try {
      handleFileRead(file);
      // const reader = new FileReader();
      // reader.onload = handleFileRead;
      // reader.readAsText(file);
    } catch (e) {
      console.log(e);
    } finally {
      setIsImporting(false);
      setFile(null);
      onClose();
    }
  }, [file]);
  const handleClose = React.useCallback(() => {
    setFile(null);
    onClose();
  }, [onClose]);
  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={isVisible}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent backgroundColor={colorStyle.background.secondary}>
        <ModalBody ml="24px" mt="16px" mb="16px">
          {isImporting ? (
            <Spinner margin="auto" />
          ) : (
            <Flex align="center">
              <Button
                variant={variant}
                onClick={() => {
                  if (uploadInputRef.current) {
                    uploadInputRef.current.click();
                  }
                }}
              >
                {t('common.action.label.chooseFile')}
              </Button>
              {/* the real upload input */}
              <input
                ref={uploadInputRef}
                type="file"
                onChange={handleFileChange}
                onClick={(e: any) => {
                  e.target.value = null;
                }}
                hidden
                accept={acceptFileType || 'text/plain, .txt'}
              />
              <Text ml={8}>
                {file === null
                  ? t('common.action.chooseFile.noChosen')
                  : (acceptFileType === FileType.TXT &&
                        FileType.TXT === file.type) ||
                      [FileType.CSV, FileType.XML].includes(acceptFileType)
                    ? file?.name
                    : // : 'Only the following file formats are supported: txt'}
                      t('common.action.chooseFile.fileFormatsTip', {
                        format: 'txt',
                      })}
              </Text>
            </Flex>
          )}
          <Text mt={12}>
            <Space>{t('globalSetting.note.title')}</Space>
            <Space width="1x"></Space>
            <Space color={colorStyle.color.secondary}>
              {t('common.note.overwritten')}
            </Space>
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            minWidth="20x"
            onClick={handleUploadClick}
            disabled={
              !(
                (acceptFileType === FileType.TXT &&
                  FileType.TXT === file?.type) ||
                [FileType.CSV, FileType.XML].includes(acceptFileType)
              ) || !file
            }
          >
            {t('common.action.label.upload')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={() => handleClose()}>
            {t('common.action.label.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ImportModal;
